/**
* @copyright Copyright (c) MITSUBISHI Electric Corporation. All rights reserved.
*/

const PAGES = {
    LOGIN: "Login",
    RESET_PASSWORD_GENERATE_CODE: "ResetPasswordGenerateCode",
    RESET_PASSWORD: "ResetPassword",
    TOTP: "Totp",
    MENUS: "Menus",
    ORGS: "Orgs",
    ACCOUNTS: "Accounts",
    ACCOUNT: "Account",
    LOGIN_ACCOUNT: "LoginAccount",
    CHANGE_TEMP_PASSWORD: "ChangeTempPassword"
}

export default PAGES